<script>
import { api } from "@/state/services";
import moment from "moment";

// Bônus de indicação recebidos no mês atual (mesmo formato YYYY-MM da tela reports/indicacao)
export default {
  data() {
    return {
      loading: true,
      errored: false,
      total: 0,
      quantity: 0,
      month: moment().format("MM/YYYY"),
    };
  },
  mounted() {
    api
      .get("report/indicacao?date=" + moment().format("YYYY-MM"))
      .then((response) => {
        if (response.data && (response.data.status == "success" || response.data.status == "empty")) {
          this.quantity = (response.data.list || []).length;
          this.total = Number(response.data.total) || 0;
        } else {
          this.errored = true;
        }
      })
      .catch(() => {
        this.errored = true;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body p-3">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="font-size-15 mb-0">Indicações do mês <small class="text-muted">{{ month }}</small></h5>
        <router-link to="/reports/indicacao" class="font-size-13">Ver relatório</router-link>
      </div>
      <div v-if="loading" class="row">
        <div class="col-6"><b-skeleton height="2.5rem"></b-skeleton></div>
        <div class="col-6"><b-skeleton height="2.5rem"></b-skeleton></div>
      </div>
      <p v-else-if="errored" class="text-muted mb-0">Não foi possível carregar as indicações agora.</p>
      <div v-else class="row">
        <div class="col-6">
          <p class="text-muted text-uppercase font-size-12 mb-1">Bônus recebidos</p>
          <h4 class="mb-0 notranslate">{{ total | currency }}</h4>
        </div>
        <div class="col-6">
          <p class="text-muted text-uppercase font-size-12 mb-1">Quantidade</p>
          <h4 class="mb-0">{{ quantity }}</h4>
        </div>
      </div>
    </div>
  </div>
</template>
